import React from 'react';
import { IoClose } from 'react-icons/io5';
import { ActionIcon, Modal, Text } from 'rizzui';
import cn from '../../utils/classNames';

interface ModalFormProps {
    isOpen: boolean;
    title: string;
    children: React.ReactNode;
    className?: string;
    containerClassName?: string;
    onClose: () => void;
}

const ModalForm: React.FC<ModalFormProps> = ({ isOpen, title, children, className, containerClassName, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName={cn(['!max-w-xl !shadow-xl'], containerClassName)}
            className={cn(['z-[9999] [&_.pointer-events-none]:overflow-visible'], className)}
        >
            <div className='m-auto px-4 md:px-7 pt-6'>
                <div className='mb-4 flex items-center justify-between'>
                    <Text className="text-xl">{title}</Text>
                    <ActionIcon size='sm' variant='text' onClick={onClose}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>
                <hr className='mb-7 border-gray-200 dark:border-gray-700' />

                {children}
            </div>
        </Modal>
    );
};

export default ModalForm;